module.exports = __webpack_public_path__ + "img/chain19.abeb427a.png";